import { CalendarAbsenceEventFormValues } from '../Components/CalendarAbsenceEvent/CalendarAbsenceEventForm';
import { getMomentDate } from '../../../Utils/dates.util';
import { getDateWithTime, Time } from '../../Base/Helpers/date.helper';

export const prepareAbsenceDateRange = (
	values: CalendarAbsenceEventFormValues,
) => {
	const { dateFrom, dateTo } = values;
	const tFrom = getMomentDate(values.timeFrom);
	const tTo = getMomentDate(values.timeTo);

	const timeFrom: Time = values.wholeDay
		? { hours: 0, minutes: 0 }
		: {
				hours: tFrom.hours(),
				minutes: tFrom.minutes(),
		  };

	const timeTo: Time = values.wholeDay
		? { hours: 23, minutes: 59 }
		: {
				hours: tTo.hours(),
				minutes: tTo.minutes(),
		  };

	return {
		start: getDateWithTime(dateFrom, timeFrom),
		end: getDateWithTime(dateTo, timeTo),
	};
};
